import { render, staticRenderFns } from "./PortfolioTable.vue?vue&type=template&id=9a13e804&scoped=true"
import script from "./PortfolioTable.vue?vue&type=script&lang=ts"
export * from "./PortfolioTable.vue?vue&type=script&lang=ts"
import style0 from "./PortfolioTable.vue?vue&type=style&index=0&id=9a13e804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a13e804",
  null
  
)

export default component.exports